import { render, staticRenderFns } from "./Pathroutes.vue?vue&type=template&id=5b7986e0&"
import script from "./Pathroutes.vue?vue&type=script&lang=js&"
export * from "./Pathroutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports